import { type PurchasePathState } from '../../types/initialState';
import coverageSectionStyles from '../CoverageSection/CoverageSection.module.scss';
import CoverageHeading from '../CoverageSelector/CoverageHeading';
import CoverageInfoModal from '../CoverageSelector/CoverageInfoModal';
import CoverageStepper from '../CoverageSelector/CoverageStepper';
import DeductibleDaysSelect from '../DeductibleDaysSelect';
import { CoverageProduct } from 'dto/marketableProduct';
import {
  useSelectedPremiums,
  useSelectablePremiums,
} from 'state/selectors/coverageSelectors';
import { getInitialState } from 'utils';

interface Props {
  displayDetails: boolean;
}

const TemporaryDisability = ({ displayDetails }: Props) => {
  const { marketableProduct } = getInitialState() as PurchasePathState;
  const selectedSumInsuredPremiums = useSelectedPremiums();
  const temporaryDisabilitySelectablePremiums = useSelectablePremiums(
    CoverageProduct.TEMPORARY_DISABILITY
  );

  const coverageProduct = CoverageProduct.TEMPORARY_DISABILITY;

  if (!temporaryDisabilitySelectablePremiums) {
    // Return null to avoid error throwing on page refresh
    return null;
  }

  const coverage = marketableProduct.coverages.find(
    (c) => c.coverageProduct === coverageProduct
  );

  if (!coverage) {
    throw new Error(
      `No coverage found for coverageProduct: ${coverageProduct}`
    );
  }
  const premium = selectedSumInsuredPremiums[coverageProduct];

  if (!premium) {
    return null;
  }

  return (
    <div
      data-testid={`coverageTile-${coverage.coverageProduct}`}
      className={coverageSectionStyles.coverageTile}>
      <CoverageHeading
        coverage={coverage}
        premium={premium}
        displayDetails={displayDetails}
      />
      {displayDetails && (
        <>
          <CoverageStepper
            coverage={coverage}
            premium={premium}
            selectablePremiums={temporaryDisabilitySelectablePremiums}
          />
          <DeductibleDaysSelect
            coverage={coverage}
            premium={premium}
            selectablePremiums={temporaryDisabilitySelectablePremiums}
          />
        </>
      )}
      <CoverageInfoModal coverage={coverage} />
    </div>
  );
};

export default TemporaryDisability;
